import React from 'react';
import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import Hidden from '@mui/material/Hidden';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../../../apps/table-tuck-web/src/environments/environment';
import { getFontFamily } from '../../../../../apps/table-tuck-web/src/app/Utils/fontLoader';

export function FattyPattyNoUser({ navigate, mdDown }) {
  const { t } = useTranslation();

  return (
    <Hidden smDown>
      <div style={{ display: 'flex', gap: '15px' }}>
        <Button
          onClick={() => navigate('/signup')}
          style={{
            border: '2px solid white',
            color: 'white',
            backgroundColor: 'transparent',
            borderRadius: '52px',
            borderColor: 'white',
            width: '126px',
            fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
            fontWeight: 700,
            height: '38px',
            fontSize: '14px',
            textTransform: 'none',
          }}
        >
          {t('signIn')}
        </Button>
        <Button
          onClick={() => navigate('/menu')}
          style={{
            border: '2px solid white',
            color: environment.mainColor,
            backgroundColor: 'white',
            borderRadius: '52px',
            width: '126px',
            fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
            fontWeight: 700,
            height: '38px',
            fontSize: '14px',
            textTransform: 'none',
          }}
        >
          Order Now
        </Button>
      </div>
    </Hidden>
  );
}

export default FattyPattyNoUser;
